import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-table-totalizers',
  templateUrl: './customer-table-totalizers.component.html',
  styleUrls: ['./customer-table-totalizers.component.sass'],
})
export class CustomerTableTotalizersComponent implements OnInit {
  @Input()
  totalizers: {
    selectTotal: number;
    registrationTotal: number;
    activeTotal: number;
    deactiveTotal: number;
    lockTotal: number;
  } = {
    selectTotal: 0,
    registrationTotal: 0,
    activeTotal: 0,
    deactiveTotal: 0,
    lockTotal: 0,
  };
  @Input()
  length: number;

  constructor() {}

  ngOnInit(): void {}
}
